export const edboFetchingStatusEnum = {
    Fetching: 0,
    Succeed: 1,
    Failed: 2,
};